import * as z from "zod";
import { string } from "zod";
export const ConfirmContactSupport = z.object({
  customerEmail: string().optional(),
  externalEmail: string().optional(),
  externalEmailMessage: string().optional(),
});
export type ConfirmContactSupportType = z.infer<typeof ConfirmContactSupport>;
